import React from 'react';
import ModalContainer from '../ModalContainer';
import { HStack, Text, VStack } from '@chakra-ui/react';
import CustomButton from '@/components/atoms/CustomButton';
import colors from '@/theme/colors';

interface Props {
  title: string;
  subTitleImage?: JSX.Element;
  description: string;
  errorText?: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirmButtonText: string;
  confirmButtonColor?: string;
  confirmLoading?: boolean;
  isConfirmButtonDisabled?: boolean;
  verticalButtons?: boolean;
}

const ConfirmationModal = ({
  title,
  subTitleImage,
  description,
  errorText,
  isOpen,
  onClose,
  onConfirm,
  confirmButtonText,
  confirmButtonColor = 'primary.500',
  confirmLoading,
  isConfirmButtonDisabled = false,
  verticalButtons = false,
}: Props) => {
  const cancelButton = (
    <CustomButton
      isTransparent
      labelColor="text.mediumBlue"
      labelHoverColor={colors.extra.black}
      label="Cancel"
      onClick={onClose}
      labelStyle={{ fontSize: '16px' }}
      style={{ marginTop: verticalButtons ? 0 : '20px' }}
      height={'60px'}
      width={'100px'}
    />
  );

  const confirmButton = (
    <CustomButton
      label={confirmButtonText}
      labelColor="extra.white"
      labelHoverColor={'extra.white'}
      backgroundColor={confirmButtonColor}
      labelStyle={{ fontSize: '16px' }}
      onClick={onConfirm}
      style={{ marginTop: verticalButtons ? 0 : '20px', paddingInline: '20px', minWidth: '100px' }}
      height={'60px'}
      isLoading={confirmLoading}
      disabled={isConfirmButtonDisabled}
    />
  );

  return (
    <ModalContainer
      isBlur={false}
      isOpen={isOpen}
      onClose={onClose}
      width={'40%'}
      height={'20vh'}
      backgroundColor="background.lightBlue"
      footerContent={
        verticalButtons ? (
          <VStack justifyContent={'center'} width={'100%'} gap={'0px'}>
            {confirmButton}
            {cancelButton}
          </VStack>
        ) : (
          <HStack justifyContent={'center'} width={'100%'} marginBottom={'20px'} gap={'30px'}>
            {cancelButton}
            {confirmButton}
          </HStack>
        )
      }
    >
      <VStack marginTop={'30px'} gap={'20px'}>
        <Text variant={'loraSmallTitle'} color={'black'}>
          {title}
        </Text>
        {subTitleImage}
        <Text fontSize={'20px'} textAlign={'center'} paddingX={'20px'} whiteSpace={'pre-wrap'}>
          {description}
        </Text>
        <Text variant={'error'} maxWidth={'80%'}>
          {errorText}
        </Text>
      </VStack>
    </ModalContainer>
  );
};

export default ConfirmationModal;
